<script setup lang="ts">
interface Props {
  color: string
}

withDefaults(defineProps<Props>(), {
  color: '#212121',
})
</script>

<template>
  <svg
    width="449"
    height="511"
    viewBox="0 0 449 511"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9277_27247)">
      <path
        d="M236.47 0C264.08 0 291.68 0 319.29 0C320.04 30.41 329.35 57.78 348.98 81.19C374.8 111.99 408.25 127.18 448.47 128.21V211.08C400.7 210.81 358.12 196.14 319.42 167.43C319.42 170.45 319.42 172.4 319.42 174.35C319.63 233.06 319.89 291.77 320.04 350.47C320.09 370.23 316.99 389.5 309.88 408.01C282.25 479.97 207.7 521.84 131.75 508.11C67.41 496.48 18 449.12 3.87 385.26C2.06 377.06 1.27 368.62 0 360.3C0 355.31 0 350.32 0 345.33C0.64 340.59 1.24 335.84 1.93 331.11C7.92 289.56 27.59 255.8 60.17 229.57C86.73 208.18 117.36 196.94 151.27 195C162.12 194.38 173.07 195.46 184.09 195.76V280.58C177.61 279.53 171.47 278.03 165.25 277.59C118.4 274.34 80.09 314.73 85.59 361.39C91.92 415.06 151.21 445.13 197.85 417.89C223.49 402.91 235.79 379.89 235.78 350.09C235.74 235.69 235.83 121.29 235.9 6.9C235.9 4.6 236.29 2.31 236.49 0.01L236.47 0Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_9277_27247">
        <rect width="448.48" height="510.7" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
